import {Card, css, Stack, styled} from '@mui/material';
import {StyledCardProps} from './types';

const StyledHeader = styled(Stack)`
	flex: 1;
	flex-direction: row;
	align-items: start;
	gap: 12px;
	width: 100%;
	justify-content: space-between;
`;

const StyledCardContainer = styled(Card)<StyledCardProps>`
	width: 100%;
	justify-content: space-between;
	flex-direction: column;
	padding: 16px;
	display: flex;
	gap: 12px;
	align-items: center;

	${({$borderTop, $borderColor, theme}) =>
		$borderTop &&
		css`
			padding-top: 12px;
			border-top: 4px solid ${$borderColor ?? theme.palette.customInfo.main};
		`}
`;

export {StyledHeader, StyledCardContainer};
